import { copyImageToClipboard } from 'copy-image-clipboard'
import { toast } from 'react-toastify'

export const getDownloadFileName = (headers: any) => {
  const disposition = headers['content-disposition']
  const matches = /"([^"]*)"/.exec(disposition)
  return matches?.[1]
}

export const downloadCSV = (csv: string, fileName: string) => {
  const blob = new Blob([csv], { type: 'text/csv' })
  const url = window.URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = fileName.endsWith('.csv') ? fileName : `${fileName}.csv`
  link.click()
}

export const copyBase64ToClipboard = async (base64Image: string) => {
  copyImageToClipboard(base64Image)
    .then(() => {
      toast.success('Image copied')
    })
    .catch((e) => {
      toast.error('Failed to copy image: ' + e?.message)
    })
}

export const downloadBase64Image = (base64Image: string, options: {
  name?: string
}) => {
  const { name = 'image.png' } = options || {}
  const link = document.createElement('a')
  link.href = base64Image
  link.download = name
  link.click()
}
